import React from 'react';

export default function GoatHornsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="29.2,21.34 21.48,21.34 20.06,9.23 27.78,9.23" fill="#D7C8D7" />
      <polygon points="21.48,21.34 29.2,21.34 27.49,22.85 19.77,22.85" fill="#AC8CAC" opacity="0.95" />
      <polygon points="21.48,21.34 19.77,22.85 18.35,10.74 20.06,9.23" fill="#AC8CAC" opacity="0.95" />
      <polygon points="12.84,21.34 5.13,21.34 3.71,9.23 11.42,9.23" fill="#D7C8D7" />
      <polygon points="5.13,21.34 12.84,21.34 11.13,22.85 3.42,22.85" fill="#AC8CAC" opacity="0.95" />
      <polygon points="5.13,21.34 3.42,22.85 2.0,10.74 3.71,9.23" fill="#AC8CAC" opacity="0.95" />
      <polygon points="30.84,23.94 24.67,23.94 25.38,18.59 31.55,18.59" fill="#D7C8D7" />
      <polygon points="24.67,23.94 30.84,23.94 27.42,17.5 21.25,17.5" fill="#AC8CAC" opacity="0.95" />
      <polygon points="24.67,23.94 21.25,17.5 21.96,12.16 25.38,18.59" fill="#AC8CAC" opacity="0.95" />
      <polygon points="14.49,23.94 8.32,23.94 9.03,18.59 15.2,18.59" fill="#D7C8D7" />
      <polygon points="8.32,23.94 14.49,23.94 11.07,17.5 4.9,17.5" fill="#AC8CAC" opacity="0.95" />
      <polygon points="8.32,23.94 4.9,17.5 5.61,12.16 9.03,18.59" fill="#AC8CAC" opacity="0.95" />
      <polygon points="32.79,16.7 29.7,16.7 29.7,10.53 32.79,10.53" fill="#D7C8D7" />
      <polygon points="29.7,16.7 32.79,16.7 30.01,15.31 26.92,15.31" fill="#AC8CAC" opacity="0.95" />
      <polygon points="29.7,16.7 26.92,15.31 26.92,9.14 29.7,10.53" fill="#AC8CAC" opacity="0.95" />
      <polygon points="16.43,16.7 13.35,16.7 13.35,10.53 16.43,10.53" fill="#D7C8D7" />
      <polygon points="13.35,16.7 16.43,16.7 13.66,15.31 10.57,15.31" fill="#AC8CAC" opacity="0.95" />
      <polygon points="13.35,16.7 10.57,15.31 10.57,9.14 13.35,10.53" fill="#AC8CAC" opacity="0.95" />
      <polygon points="38.0,27.96 32.01,33.23 29.53,12.04 35.52,6.77" fill="#AC8CAC" opacity="0.95" />
      <polygon points="21.65,27.96 15.66,33.23 13.18,12.04 19.17,6.77" fill="#AC8CAC" opacity="0.95" />
    </svg>
  );
}
